var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTooltipInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333ZM8.18 4a.667.667 0 1 1 0 1.333.667.667 0 0 1 0-1.333Zm1.333 7.833a.167.167 0 0 1-.18.167H7a.166.166 0 0 1-.167-.167V11.5A.166.166 0 0 1 7 11.333h.5v-4H7a.167.167 0 0 1-.167-.166v-.334A.167.167 0 0 1 7 6.667h1.5A.333.333 0 0 1 8.833 7v4.333h.5a.166.166 0 0 1 .167.167l.013.333Z",
  fill: "#771B61"
})));
export default SvgTooltipInfo;